
const initialState = {
  conversations: {},
  messages: {},
}

export default function conversationsReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_ALL_CONVERSATIONS':
      return {
        ...state,
        ...action.payload,
      }
    case 'CHANGE_DISPLAY_NAME':
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.payload.conversationId]: {
            ...state.conversations[action.payload.conversationId],
            consumer: {
              ...state.conversations[action.payload.conversationId].consumer,
              displayName: action.payload.displayName,
            },
          },
        },
      }
    case 'SET_UIMEMO_SCROLL':
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.payload.conversationId]: {
            ...state.conversations[action.payload.conversationId],
            uiMemo: {
              ...state.conversations[action.payload.conversationId].uiMemo,
              scroll: action.payload.scroll,
              delta: action?.payload?.delta,
            },
          },
        },
      }
    case 'SET_CONVERSATIONS': {
      const { message: messages, ...conversation } = action.payload
      const chatId = conversation?.conversationId
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [chatId]: conversation,
        },
        messages: {
          ...state.messages,
          [chatId]: messages ?? state.messages[chatId],
        },
      }
    }

    case 'SET_NEW_AGENT_MESSAGE': {
      const { message, chatId, conversationData  } = action.payload
      if(conversationData.idleMessage && conversationData.statusTriggers){
        return {
          ...state,
          conversations: {
            ...state.conversations,
            [chatId]: {
              ...state.conversations[chatId],
              idleMessage: conversationData.idleMessage,
              statusTriggers: conversationData.statusTriggers,
              lastMessage: conversationData.lastMessage,
            }
          },
          messages: {
            ...state.messages,
            [chatId]: [...state.messages[chatId], message],
          }
        }
      }
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [chatId]: {
            ...state.conversations[chatId],
            lastMessage: conversationData.lastMessage,
          }
        },
        messages: {
          ...state.messages,
          [chatId]: [...state.messages[chatId], message],
        }
      }
    }

    case 'SET_NEW_AI_MESSAGE': {
      const { message, chatId, messageId } = action.payload

      const indexMessage = state.messages[chatId].findIndex(
        (msg) => msg.currentId === messageId
      )
      state.messages[chatId][indexMessage] = message

      return {
        ...state,
        conversations: {
          ...state.conversations,
          [chatId]: {
            ...state.conversations[chatId],
          },
        },
        messages: {
          ...state.messages,
          [chatId]: [...state.messages[chatId]],
        },
      }
    }

    case 'SET_UPDATE_AGENT_MESSAGE_SUCCESS': {
      const { chatId, message, response } = action.payload    
      return {
        ...state,
        messages: {
          ...state.messages,
          [chatId]: state.messages[chatId].map((msg) => {
            if (msg?._id !== message?._id) {
              return msg
            } 
            return {
              ...msg,
              currentId: response?.currentId,
              previousId: response?.previousId,
              files: response?.files ?? {},
              text: response?.message ?? '',
              status: {
                ...message.status,
                sending: false,
                delivered: true
              }
            }
          })
        }
      }  
    }

    case 'SET_UPDATE_AGENT_MESSAGE_ERROR': {
      const { chatId, message } = action.payload
      return {
        ...state,
        messages: {
          ...state.messages,
          [chatId]: state.messages[chatId].map((msg) => {
            if (msg?._id !== message?._id) {
              return msg
            } 
            return {
              ...msg,
              status: {
                ...message.status,
                sending: false,
                error: true
              },
            }
          })
        }
      } 
    }

    case 'ADD_NEW_USER_MESSAGE': {
      const { messages = [], chatId, conversationData, user, joinUserToChat } = action.payload

      if (!messages.length) return state

      return {
        ...state,
        conversations: {
          ...state.conversations,
          [chatId]: {
            ...state.conversations[chatId],
            idleMessage: conversationData.idleMessage,
            statusTriggers: conversationData.statusTriggers,
            lastMessage: messages[messages.length - 1],
            users: [
              ...state.conversations[chatId].users ?? [],
              ...joinUserToChat && user ? [user] : []
            ]
          }
        },
        messages: {
          ...state.messages,
          [chatId]: [
            ...state.messages[chatId],
            ...messages.map(message => ({ ...message, unread: true }))
          ],
        }
      }
    }

    case 'DELETE_CONVERSATIONS': {
      const conversationId = action.payload
      const { [conversationId]: chatDeleted, ...newChats } = state?.conversations || {}
      const { [conversationId]: msgDeleted, ...newMsgs } = state?.messages || {}
      return {
        ...state,
        conversations: newChats,
        messages: newMsgs,
      }
    }
    case 'SET_MESSAGES': {
      const { message: messages, ...conversation } = action.payload
      const chatId = conversation?.conversationId
      return {
        ...state,
        messages: {
          ...state.messages,
          [chatId]: messages ?? state.messages[chatId],
        },
      }
    }

    case 'SET_FILE_DROP':
      var fileObject = action?.payload?.map((fileObject) =>{
        var newObject  = {
          'url'              : URL.createObjectURL(fileObject),
          'lastModified'     : fileObject.lastModified,
          'lastModifiedDate' : fileObject.lastModifiedDate,
          'name'             : fileObject.name,
          'size'             : fileObject.size,
          'type'             : fileObject.type
        };  
       return newObject;
      });
      return {
        ...state,
        files: fileObject,
      }

    default:
      return state
  }
}
